export const ORDER_STATUS_LABELS: Record<string, string> = {
  inactive: 'Inactive',
  pending_confirmation: 'Pend. Confirm.',
  new: 'New',
  cancelled: 'Cancelled',
  partial: 'Partially Filled',
  filled: 'Filled',
  rejected: 'Rejected',
};

export function getOrderStatusLabel(status: string): string {
  return ORDER_STATUS_LABELS[status] ?? status;
}

export function getOrderStatusColor(status: string): string {
  switch (status) {
    case 'filled':
      return 'success';
    case 'cancelled':
    case 'rejected':
      return 'error';
    case 'partial':
    case 'pending_confirmation':
      return 'warning';
    case 'inactive':
      return 'default';
    default:
      return 'processing';
  }
}
